class DraggableSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.slider');
    if (!this.slider) return;

    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.snapTimeout = null;

    this.onMouseMoveBound = this.onMouseMove.bind(this);
    this.onMouseUpBound = this.onMouseUp.bind(this);

    this.slider.addEventListener('mousedown', this.onMouseDown.bind(this));
    
    // Prevent default drag behavior on all descendants (images, links, text)
    this.slider.addEventListener('dragstart', (e) => e.preventDefault());
  }

  onMouseDown(e) {
    if (this.snapTimeout) {
      clearTimeout(this.snapTimeout);
      this.snapTimeout = null;
    }

    this.isDown = true;
    this.slider.classList.add('active');
    this.startX = e.pageX - this.slider.offsetLeft;
    this.scrollLeft = this.slider.scrollLeft;
    
    // Disable scroll snapping and smooth scroll behavior during drag
    this.slider.style.setProperty('scroll-behavior', 'auto', 'important');
    this.slider.style.setProperty('scroll-snap-type', 'none', 'important');
    this.slider.style.cursor = 'grabbing';

    window.addEventListener('mousemove', this.onMouseMoveBound);
    window.addEventListener('mouseup', this.onMouseUpBound);
  }

  onMouseUp(e) {
    if (!this.isDown) return;
    this.isDown = false;
    this.slider.classList.remove('active');
    this.slider.style.cursor = '';
    
    const x = e.pageX - this.slider.offsetLeft;
    const walk = (x - this.startX);
    
    let targetScroll = this.slider.scrollLeft;
    const slide = this.slider.querySelector('.slider__slide');
    
    if (slide) {
        const gap = parseFloat(window.getComputedStyle(this.slider).gap) || 0;
        const scrollStep = slide.clientWidth + gap;
        const maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;
        
        // Calculate the perfectly snapped starting point
        const closestOriginalIndex = Math.round(this.scrollLeft / scrollStep);
        const snappedOriginalScroll = closestOriginalIndex * scrollStep;

        if (Math.abs(walk) > 20) {
            const slidesDragged = Math.round(Math.abs(walk) / scrollStep);
            if (walk < 0) { // dragged left, scroll right
                targetScroll = snappedOriginalScroll + (Math.max(1, slidesDragged) * scrollStep);
            } else { // dragged right, scroll left
                targetScroll = snappedOriginalScroll - (Math.max(1, slidesDragged) * scrollStep);
            }
        } else {
            targetScroll = snappedOriginalScroll;
        }

        // Clamp to min and max boundaries
        targetScroll = Math.max(0, Math.min(targetScroll, maxScrollLeft));

        // If targetScroll is very close to the end, lock to maxScrollLeft
        if (targetScroll > maxScrollLeft - (scrollStep / 2)) {
            targetScroll = maxScrollLeft;
        }
    }

    // Smoothly scroll to the perfectly snapped target
    this.slider.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
    });

    // Wait for smooth scroll to finish before restoring native scroll-snap
    this.snapTimeout = setTimeout(() => {
      this.slider.style.removeProperty('scroll-behavior');
      this.slider.style.removeProperty('scroll-snap-type');
    }, 400);

    window.removeEventListener('mousemove', this.onMouseMoveBound);
    window.removeEventListener('mouseup', this.onMouseUpBound);
  }

  onMouseMove(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.slider.offsetLeft;
    const walk = (x - this.startX); 
    this.slider.scrollLeft = this.scrollLeft - walk;
  }
}

if (!customElements.get('draggable-slider')) {
  customElements.define('draggable-slider', DraggableSlider);
}
